import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgGrowOnEventDirective, NgGrowOnMouseHoverDirective, NgPulseGrowOnEventDirective, NgPulseGrowOnMouseHoverDirective, NgPulseShrinkOnEventDirective, NgPulseShrinkOnMouseHoverDirective, NgShrinkOnEventDirective, NgShrinkOnMouseHoverDirective, NgPushOnEventDirective, NgPushOnMouseHoverDirective, NgPopOnEventDirective, NgPopOnMouseHoverDirective, NgPulseOnEventDirective, NgPulseOnMouseHoverDirective } from './grow';
import { NgRotateOnEventDirective, NgRotateOnMouseHoverDirective, NgGrowRotateOnEventDirective, NgGrowRotateOnMouseHoverDirective, NgRotateOppositeOnEventDirective, NgRotateOppositeOnMouseHoverDirective, NgGrowRotateOppositeOnEventDirective, NgGrowRotateOppositeOnMouseHoverDirective } from './rotate';
import { NgWobbleHorizontalOnEventDirective, NgWobbleHorizontalOnMouseHoverDirective, NgWobbleVerticalOnEventDirective, NgWobbleVerticalOnMouseHoverDirective, NgWobbleBottomOnEventDirective, NgWobbleBottomOnMouseHoverDirective, NgWobbleTopOnEventDirective, NgWobbleTopOnMouseHoverDirective, NgWobbleSkewOnEventDirective, NgWobbleSkewOnMouseHoverDirective, NgWobbleToTopRightOnEventDirective, NgWobbleToTopRightOnMouseHoverDirective, NgWobbleToBottomRightOnEventDirective, NgWobbleToBottomRightOnMouseHoverDirective } from './wobble';
import { NgFloatOnEventDirective, NgFloatOnMouseHoverDirective, NgSinkOnEventDirective, NgSinkOnMouseHoverDirective, NgBobOnEventDirective, NgBobOnMouseHoverDirective, NgHangOnEventDirective, NgHangOnMouseHoverDirective } from './float';
import { NgSkewOnEventDirective, NgSkewOnMouseHoverDirective, NgSkewForwardOnEventDirective, NgSkewForwardOnMouseHoverDirective, NgSkewBackwardOnEventDirective, NgSkewBackwardOnMouseHoverDirective } from './skew';
import { NgForwardOnEventDirective, NgForwardOnMouseHoverDirective, NgBackwardOnEventDirective, NgBackwardOnMouseHoverDirective } from './others';
import { NgBuzzOnEventDirective, NgBuzzOnMouseHoverDirective, NgBuzzOutOnEventDirective, NgBuzzOutOnMouseHoverDirective } from './buzz';


@NgModule({
	declarations: [
		NgGrowOnEventDirective,
		NgGrowOnMouseHoverDirective,
		NgRotateOnEventDirective,
		NgRotateOnMouseHoverDirective,
		NgRotateOppositeOnEventDirective,
		NgRotateOppositeOnMouseHoverDirective,
		NgGrowRotateOnEventDirective,
		NgGrowRotateOnMouseHoverDirective,
		NgGrowRotateOppositeOnEventDirective,
		NgGrowRotateOppositeOnMouseHoverDirective,
		NgFloatOnEventDirective,
		NgFloatOnMouseHoverDirective,
		NgSinkOnEventDirective,
		NgSinkOnMouseHoverDirective,
		NgSkewOnEventDirective,
		NgSkewOnMouseHoverDirective,
		NgSkewForwardOnEventDirective,
		NgSkewForwardOnMouseHoverDirective,
		NgSkewBackwardOnEventDirective,
		NgSkewBackwardOnMouseHoverDirective,
		NgForwardOnEventDirective,
		NgForwardOnMouseHoverDirective,
		NgBackwardOnEventDirective,
		NgBackwardOnMouseHoverDirective,
		NgPulseOnMouseHoverDirective,
		NgPulseOnEventDirective,
		NgPulseGrowOnEventDirective,
		NgPulseGrowOnMouseHoverDirective,
		NgPulseShrinkOnEventDirective,
		NgPulseShrinkOnMouseHoverDirective,
		NgShrinkOnEventDirective,
		NgShrinkOnMouseHoverDirective,
		NgBobOnEventDirective,
		NgBobOnMouseHoverDirective,
		NgHangOnEventDirective,
		NgHangOnMouseHoverDirective,
		NgBuzzOnEventDirective,
		NgBuzzOnMouseHoverDirective,
		NgPushOnEventDirective,
		NgPushOnMouseHoverDirective,
		NgPopOnEventDirective,
		NgPopOnMouseHoverDirective,
		NgBuzzOutOnEventDirective,
		NgBuzzOutOnMouseHoverDirective,
		NgWobbleHorizontalOnEventDirective,
		NgWobbleHorizontalOnMouseHoverDirective,
		NgWobbleVerticalOnEventDirective,
		NgWobbleVerticalOnMouseHoverDirective,
		NgWobbleBottomOnEventDirective,
		NgWobbleBottomOnMouseHoverDirective,
		NgWobbleTopOnEventDirective,
		NgWobbleTopOnMouseHoverDirective,
		NgWobbleSkewOnEventDirective,
		NgWobbleSkewOnMouseHoverDirective,
		NgWobbleToTopRightOnEventDirective,
		NgWobbleToTopRightOnMouseHoverDirective,
		NgWobbleToBottomRightOnEventDirective,
		NgWobbleToBottomRightOnMouseHoverDirective
	],
	imports: [
		CommonModule
	],
	exports: [
		NgGrowOnEventDirective,
		NgGrowOnMouseHoverDirective,
		NgRotateOnEventDirective,
		NgRotateOnMouseHoverDirective,
		NgRotateOppositeOnEventDirective,
		NgRotateOppositeOnMouseHoverDirective,
		NgGrowRotateOnEventDirective,
		NgGrowRotateOnMouseHoverDirective,
		NgGrowRotateOppositeOnEventDirective,
		NgGrowRotateOppositeOnMouseHoverDirective,
		NgFloatOnEventDirective,
		NgFloatOnMouseHoverDirective,
		NgSinkOnEventDirective,
		NgSinkOnMouseHoverDirective,
		NgSkewOnEventDirective,
		NgSkewOnMouseHoverDirective,
		NgSkewForwardOnEventDirective,
		NgSkewForwardOnMouseHoverDirective,
		NgSkewBackwardOnEventDirective,
		NgSkewBackwardOnMouseHoverDirective,
		NgForwardOnEventDirective,
		NgForwardOnMouseHoverDirective,
		NgBackwardOnEventDirective,
		NgBackwardOnMouseHoverDirective,
		NgPulseOnMouseHoverDirective,
		NgPulseOnEventDirective,
		NgPulseGrowOnEventDirective,
		NgPulseGrowOnMouseHoverDirective,
		NgPulseShrinkOnEventDirective,
		NgPulseShrinkOnMouseHoverDirective,
		NgShrinkOnEventDirective,
		NgShrinkOnMouseHoverDirective,
		NgBobOnEventDirective,
		NgBobOnMouseHoverDirective,
		NgHangOnEventDirective,
		NgHangOnMouseHoverDirective,
		NgBuzzOnEventDirective,
		NgBuzzOnMouseHoverDirective,
		NgPushOnEventDirective,
		NgPushOnMouseHoverDirective,
		NgPopOnEventDirective,
		NgPopOnMouseHoverDirective,
		NgBuzzOutOnEventDirective,
		NgBuzzOutOnMouseHoverDirective,
		NgWobbleHorizontalOnEventDirective,
		NgWobbleHorizontalOnMouseHoverDirective,
		NgWobbleVerticalOnEventDirective,
		NgWobbleVerticalOnMouseHoverDirective,
		NgWobbleBottomOnEventDirective,
		NgWobbleBottomOnMouseHoverDirective,
		NgWobbleTopOnEventDirective,
		NgWobbleTopOnMouseHoverDirective,
		NgWobbleSkewOnEventDirective,
		NgWobbleSkewOnMouseHoverDirective,
		NgWobbleToTopRightOnEventDirective,
		NgWobbleToTopRightOnMouseHoverDirective,
		NgWobbleToBottomRightOnEventDirective,
		NgWobbleToBottomRightOnMouseHoverDirective
	]
})
export class NgElementAnimationModule { }
